<template>
    <div class="header">
        <div class="introduce">
            <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/header_pic.png" alt="" />
            <div class="text">
                <p>歡樂大東家</p>
                <p>回到古代 做點買賣</p>
            </div>
        </div>
        <a class="btn_download" @click="onDownload()"></a>
        <div class="menu" :class="{ close: isExpand }" @click="isExpand = !isExpand"></div>
        <div class="side-bar" @touchmove.prevent :class="{ show: isExpand, 'other-page': !is_home }">
            <div :class="['sidebar', !isFirst ? (isExpand ? 'expand' : 'noexpand') : '']">
                <div class="left-logo">
                    <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/logo.png" alt="" />
                </div>
                <div class="nav">
                    <ul>
                        <li v-for="(item, index) in navList" :class="[currentTab == index ? 'active' : '']"
                            :key="item.name" @click="clickItem(index, item.link)">
                            <div v-if="currentTab == index">
                                <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/icon.png" alt="" /> {{ item.name }}
                                <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/icon.png" alt="" />
                            </div>
                            <div v-else>{{ item.name }}</div>
                        </li>
                    </ul>
                </div>
                <!-- <div class="login" @click="callLoginFb">
                <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/login.png" alt="" />登入
                </div> -->
                <!-- 激活 -->
                <div class="contact">
                    <a class="link" href="https://play.google.com/store/apps/details?id=com.lets.psan.hwft"
                        target="_blank"></a>
                    <a class="link" href="https://itunes.apple.com/tw/app/id1572988056" target="_blank"></a>
                    <a class="link" href="https://www.facebook.com/happybigboss" target="_blank"></a>
                </div>
                <div class="expand-btn" @click="expandBar">
                    <img v-if="!isExpand" src="https://staticweb.ewan.cn/resources/img/ddj-tw/expand_btn.png" alt="" />
                    <img v-else src="https://staticweb.ewan.cn/resources/img/ddj-tw/collapse_btn.png" alt="" />
                </div>
                <!-- facebook -->
                <!-- <v-facebook-login @sdk-init="sdkInitHandle" v-show="false" @login="fbLoginHandle" app-id="1277616899102578"></v-facebook-login> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            isExpand: false,
            isFirst: true,
            state: this.$store.state,
        };
    },
    watch: {
        is_home(newVal) {
            if (!newVal) {
                this.currentTab = 1;
            }
        },
    },
    computed: {
        navList() {
            return this.state.navList;
        },
        currentTab: {
            get() {
                return this.state.currentTab;
            },
            set(val) {
                this.state.currentTab = val;
            },
        },
        cur_route() {
            return this.state.currentRoute;
        },
        // 是否在首页
        is_home() {
            return this.cur_route == "Home";
        },
    },
    methods: {
        clickItem(index, link) {
            this.isExpand = !this.isExpand;
            this.currentTab = index;
            this.goCombtn(link);
            this.isExpand = false;
        },
        goCombtn(link) {
            if (link === "order") {
                window.location.href = "https://osg.iyagames.com/tw/#/login" 
            }
            if (link !== "#" && this.$router.currentRoute.name == "Home") {
                if (link.includes("game")) {
                    document.querySelector(link).scrollIntoView(false);
                } else {
                    document.querySelector(link).scrollIntoView(true);
                }
            } else {
                this.$router.push("/");
                setTimeout(() => {
                    document.querySelector(link).scrollIntoView(true);
                }, 500);
            }
        },
        expandBar() {
            this.isExpand = !this.isExpand;
            this.isFirst = false;
        },
        onDownload() {
            var u = navigator.userAgent;
            var ua = u.toLowerCase();
            // window.open("https://happyboss.onelink.me/vJom/7a475399");
            if (/iphone|ipad|ipod/.test(ua)) {
                window.open("https://itunes.apple.com/tw/app/id1572988056");
                //ios
            } else if (/android/.test(ua)) {
                window.open(
                    "https://play.google.com/store/apps/details?id=com.lets.psan.hwft"
                );
                //android
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@keyframes expand {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(0);
    }
}

@keyframes noexpand {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-100%);
    }
}

@media screen and (max-width: 768px) {
    .header {
        width: 100%;
        height: 102px;
        background: url("https://staticweb.ewan.cn/resources/img/ddj-tw/m_top_bar.png") no-repeat;
        background-size: cover;
        display: flex;
        justify-content: space-between;
        padding: 0 26px;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;

        .introduce {
            position: relative;
            z-index: 30;
            margin-top: 15px;

            img {
                width: 100px;
                height: 100px;
                float: left;
            }

            .text {
                float: left;
                font-size: 24px;
                color: #fff;
                font-family: "GenJyuuGothic-P-Regular";
                margin-top: 12px;
                margin-left: 20px;
            }
        }

        .btn_download {
            width: 161px;
            height: 65px;
            display: block;
            position: absolute;
            top: 18.5px;
            right: 100px;
            background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/btn_download.png) no-repeat no-repeat;
            background-size: 100% 100%;
        }

        .menu {
            width: 48px;
            height: 28px;
            background: url("https://staticweb.ewan.cn/resources/img/ddj-tw/header_menu.png") no-repeat;
            background-size: contain;
            margin-top: 36px;

            &.close {
                width: 30px;
                height: 29px;
                background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/header_menu_close.png);
            }
        }
    }

    .side-bar {
        position: fixed;
        right: 0;
        top: 102px;
        height: 100%;
        width: 100%;
        z-index: 20;
        display: none;
        background-color: rgba($color: #000000, $alpha: 0.8);

        &.show {
            display: block;
        }

        .sidebar {
            position: absolute;
            right: 0;
            top: 0;
            width: 290px;
            height: calc(100% - 102px);
            z-index: 1000;
            background-image: url("https://staticweb.ewan.cn/resources/img/ddj-tw/pc_sidebar.jpg");
            background-repeat: no-repeat;
            box-shadow: 0px 15px 10px -15px #000000;
            display: flex;
            flex-direction: column;
            align-items: center;

            &.noexpand {
                //收起
                // animation: noexpand .5s ease-in 1;
                // animation-fill-mode: forwards;
                display: none;
            }

            &.expand {
                //展开
                // animation: expand .5s ease-in 1;
                // animation-fill-mode: forwards;
                display: flex;
            }

            .left-logo {
                margin-top: 112px;
                border: none;

                >img {
                    width: 241px;
                    height: 112px;
                }
            }

            .nav {
                margin-top: 120px;
                margin-bottom: 70px;

                ul>li {
                    font-family: GenJyuuGothic-P-Medium;
                    font-size: 30px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 65px;
                    letter-spacing: -1px;
                    color: #b1784e;
                    height: 87.5px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 175px;
                    border-top: 1px dotted #ccaf9a;
                    user-select: none;
                    -webkit-tap-highlight-color: transparent;
                    cursor: pointer;

                    &:last-child {
                        border-bottom: 1px dotted #ccaf9a;
                    }

                    &:hover {
                        color: #ff8508;
                    }

                    &.active {
                        color: #ff8508;
                    }

                    img {
                        width: 18px;
                        height: auto;
                    }
                }
            }

            .login {
                font-family: GenJyuuGothic-P-Medium;
                font-size: 32px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 65px;
                letter-spacing: -1px;
                color: #b1784e;
                display: flex;
                justify-content: center;
                width: 100%;
                align-items: center;
                cursor: pointer;

                >img {
                    width: 20px;
                    margin-right: 10px;
                }
            }

            .contact {
                width: 100%;
                padding: 0 37px;
                display: flex;
                justify-content: space-around;
                align-items: center;
                margin-top: 92px;

                >.link {
                    display: inline-block;
                    width: 55px;
                    height: 55px;

                    &:nth-child(1) {
                        &:hover {
                            background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/google_login.png);
                        }

                        background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/google_active.png);
                        background-size: cover;
                        background-repeat: no-repeat;
                    }

                    &:nth-child(2) {
                        &:hover {
                            background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/apple_login.png);
                        }

                        background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/apple_active.png);
                        background-size: contain;
                        background-repeat: no-repeat;
                    }

                    &:nth-child(3) {
                        &:hover {
                            background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/facebook.png);
                        }

                        background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/facebook_active.png);
                        background-size: contain;
                        background-repeat: no-repeat;
                    }
                }
            }

            .expand-btn {
                display: none;
            }
        }
    }
}

@media screen and (min-width: 769px) {
    .side-bar {
        display: block;

        &.other-page {
            display: none;
        }

        .sidebar {
            position: fixed;
            width: 217px;
            height: 978px;
            z-index: 1000;
            background-image: url("https://staticweb.ewan.cn/resources/img/ddj-tw/pc_sidebar.jpg");
            background-repeat: no-repeat;
            box-shadow: 0px 15px 10px -15px #000000;
            display: flex;
            flex-direction: column;
            align-items: center;
            transform: translateX(-100%);

            &.expand {
                //收起
                animation: expand 0.5s ease-in 1;
                animation-fill-mode: forwards;
            }

            &.noexpand {
                //展开
                animation: noexpand 0.5s ease-in 1;
                animation-fill-mode: forwards;
            }

            .left-logo {
                margin-top: 155px;
                border: none;

                >img {
                    width: 184px;
                    height: 86px;
                }
            }

            .nav {
                margin-top: 55px;
                margin-bottom: 122px;

                ul>li {
                    font-family: GenJyuuGothic-P-Medium;
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 65px;
                    letter-spacing: -1px;
                    color: #b1784e;
                    height: 87.5px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 150px;
                    border-top: 1px dotted #ccaf9a;
                    cursor: pointer;

                    img {
                        width: 14px;
                        height: auto;
                    }

                    &:last-child {
                        border-bottom: 1px dotted #ccaf9a;
                    }

                    &:hover {
                        color: #ff8508;
                    }

                    &.active {
                        color: #ff8508;
                    }
                }
            }

            .login {
                font-family: GenJyuuGothic-P-Medium;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 65px;
                letter-spacing: -1px;
                color: #b1784e;
                display: flex;
                justify-content: center;
                width: 100%;
                align-items: center;
                cursor: pointer;

                >img {
                    width: 13px;
                    height: 18px;
                    margin-right: 10px;
                }
            }

            .contact {
                width: 100%;
                padding: 0 37px;
                display: flex;
                justify-content: space-around;
                align-items: center;
                margin-top: 20px;

                >.link {
                    display: inline-block;
                    width: 37px;
                    height: 36px;

                    &:nth-child(1) {
                        &:hover {
                            background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/google_login.png);
                        }

                        background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/google_active.png);
                        background-size: cover;
                        background-repeat: no-repeat;
                    }

                    &:nth-child(2) {
                        &:hover {
                            background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/apple_login.png);
                        }

                        background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/apple_active.png);
                        background-size: cover;
                        background-repeat: no-repeat;
                    }

                    &:nth-child(3) {
                        &:hover {
                            background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/facebook.png);
                        }

                        background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/facebook_active.png);
                        background-size: cover;
                        background-repeat: no-repeat;
                    }
                }
            }

            .expand-btn {
                position: absolute;
                left: 100%;
                top: calc(50% - 83px);
                cursor: pointer;

                img {
                    width: 90px;
                    height: 160px;
                }
            }
        }
    }

    .introduce {
        display: none;
    }
}
</style>